// // dashboard-frontend/src/components/AdminSponsorManagement.jsx
// import React, { useState, useEffect } from 'react';
// import { fetchJSON, API_BASE } from '../api';
// import ImageCropper from './ImageCropper';

// /**
//  * AdminSponsorManagement
//  * Allows 'master_admin' or 'graphics' roles to upload or delete
//  * a single sponsor image. All other roles see a "no permission" message.
//  */
// const AdminSponsorManagement = () => {
//   const currentUser = JSON.parse(localStorage.getItem("dashboardUser") || "{}");

//   const [sponsors, setSponsors] = useState([]);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [croppedBlob, setCroppedBlob] = useState(null);
//   const [cropModalOpen, setCropModalOpen] = useState(false);
//   const [imageSrc, setImageSrc] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [hasPermission, setHasPermission] = useState(false);

//   // Decide if user has permission (master_admin or graphics)
//   useEffect(() => {
//     if (currentUser.role === 'master_admin' || currentUser.role === 'graphics') {
//       setHasPermission(true);
//     } else {
//       setHasPermission(false);
//     }
//   }, [currentUser.role]);

//   // Fetch existing sponsor images
//   const fetchSponsors = async () => {
//     try {
//       // fetchJSON automatically includes the token in headers
//       const data = await fetchJSON('/api/sponsors');
//       setSponsors(data);
//     } catch (err) {
//       console.error('Error fetching sponsors:', err);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchSponsors();
//   }, []);

//   // Handle file selection
//   const handleFileChange = (e) => {
//     if (sponsors.length > 0) {
//       alert('A sponsor image already exists. Delete it before uploading a new one.');
//       return;
//     }
//     if (e.target.files && e.target.files.length > 0) {
//       const file = e.target.files[0];
//       setSelectedFile(file);
//       const reader = new FileReader();
//       reader.onload = () => {
//         setImageSrc(reader.result);
//         setCropModalOpen(true);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Called after cropping is complete
//   const handleCropComplete = (cropped) => {
//     setCroppedBlob(cropped);
//     setCropModalOpen(false);
//   };

//   // Cancel cropping
//   const handleCropCancel = () => {
//     setCropModalOpen(false);
//     setSelectedFile(null);
//     setImageSrc(null);
//   };

//   // Upload the cropped sponsor image
//   const handleUpload = async () => {
//     if (!croppedBlob) {
//       alert('Please select and crop an image first.');
//       return;
//     }
//     if (!hasPermission) {
//       alert('You do not have permission to upload.');
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append('image', croppedBlob, selectedFile.name);

//       // Because we are sending multipart form data,
//       // do a manual fetch call with the token in the Authorization header
//       const token = localStorage.getItem('token') || '';
//       const response = await fetch(`${API_BASE}/api/sponsors`, {
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`
//         },
//         body: formData
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.error || 'File upload failed');
//       }

//       const newSponsor = await response.json();
//       setSponsors([newSponsor]);
//       setSelectedFile(null);
//       setCroppedBlob(null);
//       setImageSrc(null);
//       alert('File uploaded successfully!');
//     } catch (err) {
//       console.error(err);
//       alert(err.message);
//     }
//   };

//   // Delete sponsor image
//   const handleDelete = async (id) => {
//     if (!hasPermission) {
//       alert('You do not have permission to delete.');
//       return;
//     }
//     if (!window.confirm('Are you sure you want to delete this sponsor image?')) {
//       return;
//     }
//     try {
//       // For DELETE, we can use fetchJSON which attaches the token
//       await fetchJSON(`/api/sponsors/${id}`, { method: 'DELETE' });
//       setSponsors([]);
//       alert('Sponsor deleted successfully.');
//     } catch (err) {
//       console.error(err);
//       alert(err.message);
//     }
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-2xl font-bold mb-4">Sponsor Management</h2>
//       {!hasPermission ? (
//         <p>You do not have permission to manage sponsors.</p>
//       ) : (
//         <>
//           <div className="mb-4 flex flex-col md:flex-row items-start md:items-end gap-2">
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleFileChange}
//               disabled={sponsors.length > 0}
//               className="border p-2 rounded"
//             />
//             <button
//               onClick={handleUpload}
//               disabled={sponsors.length > 0 || !croppedBlob}
//               className="bg-primary text-white px-4 py-2 rounded"
//             >
//               Upload Sponsor Image
//             </button>
//           </div>

//           {selectedFile && !cropModalOpen && (
//             <div className="mb-4">
//               <p>File selected: {selectedFile.name}</p>
//             </div>
//           )}

//           {/* Image Crop Modal */}
//           {cropModalOpen && imageSrc && (
//             <ImageCropper
//               imageSrc={imageSrc}
//               aspect={1448 / 469}
//               onCropComplete={handleCropComplete}
//               onCancel={handleCropCancel}
//             />
//           )}

//           {loading ? (
//             <p>Loading sponsor images...</p>
//           ) : (
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//               {sponsors.map((sponsor) => (
//                 <div key={sponsor._id} className="border p-2 rounded shadow flex flex-col items-center">
//                   <img
//                     src={`/uploads/sponsors/${sponsor.filename}`}
//                     alt="Sponsor"
//                     className="w-full h-32 object-contain mb-2"
//                   />
//                   <button
//                     onClick={() => handleDelete(sponsor._id)}
//                     className="bg-red-500 text-white px-2 py-1 rounded mt-auto"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default AdminSponsorManagement;


// dashboard-frontend/src/components/AdminSponsorManagement.jsx

import React, { useState, useEffect } from 'react';
import { fetchJSON, API_BASE } from '../api';
import ImageCropper from './ImageCropper';

/**
 * AdminSponsorManagement
 * Allows 'master_admin' or 'graphics' roles to upload or delete
 * a single sponsor image. All other roles see a "no permission" message.
 */
const AdminSponsorManagement = () => {
  const currentUser = JSON.parse(localStorage.getItem("dashboardUser") || "{}");

  const [sponsors, setSponsors] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [croppedBlob, setCroppedBlob] = useState(null);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(false);

  // Decide if user has permission (master_admin or graphics)
  useEffect(() => {
    if (currentUser.role === 'master_admin' || currentUser.role === 'graphics') {
      setHasPermission(true);
    } else {
      setHasPermission(false);
    }
  }, [currentUser.role]);

  // Fetch existing sponsor images (protected route)
  const fetchSponsors = async () => {
    try {
      // fetchJSON automatically includes the token
      const data = await fetchJSON('/api/sponsors');
      setSponsors(data);
    } catch (err) {
      console.error('Error fetching sponsors:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSponsors();
  }, []);

  // Handle file selection
  const handleFileChange = (e) => {
    if (sponsors.length > 0) {
      alert('A sponsor image already exists. Delete it before uploading a new one.');
      return;
    }
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        setCropModalOpen(true);
      };
      reader.readAsDataURL(file);
    }
  };

  // Crop complete
  const handleCropComplete = (cropped) => {
    setCroppedBlob(cropped);
    setCropModalOpen(false);
  };

  // Cancel cropping
  const handleCropCancel = () => {
    setCropModalOpen(false);
    setSelectedFile(null);
    setImageSrc(null);
  };

  // Upload the cropped sponsor image
  const handleUpload = async () => {
    if (!croppedBlob) {
      alert('Please select and crop an image first.');
      return;
    }
    if (!hasPermission) {
      alert('You do not have permission to upload.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('image', croppedBlob, selectedFile.name);

      // Because we are sending multipart form data,
      // do a manual fetch call with the token in the Authorization header
      const token = localStorage.getItem('token') || '';
      const response = await fetch(`${API_BASE}/api/sponsors`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'File upload failed');
      }

      const newSponsor = await response.json();
      setSponsors([newSponsor]);
      setSelectedFile(null);
      setCroppedBlob(null);
      setImageSrc(null);
      alert('File uploaded successfully!');
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  // Delete sponsor image
  const handleDelete = async (id) => {
    if (!hasPermission) {
      alert('You do not have permission to delete.');
      return;
    }
    if (!window.confirm('Are you sure you want to delete this sponsor image?')) {
      return;
    }
    try {
      await fetchJSON(`/api/sponsors/${id}`, { method: 'DELETE' });
      setSponsors([]);
      alert('Sponsor deleted successfully.');
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Sponsor Management</h2>
      {!hasPermission ? (
        <p>You do not have permission to manage sponsors.</p>
      ) : (
        <>
          <div className="mb-4 flex flex-col md:flex-row items-start md:items-end gap-2">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              disabled={sponsors.length > 0}
              className="border p-2 rounded"
            />
            <button
              onClick={handleUpload}
              disabled={sponsors.length > 0 || !croppedBlob}
              className="bg-primary text-white px-4 py-2 rounded"
            >
              Upload Sponsor Image
            </button>
          </div>

          {selectedFile && !cropModalOpen && (
            <div className="mb-4">
              <p>File selected: {selectedFile.name}</p>
            </div>
          )}

          {/* Image Crop Modal */}
          {cropModalOpen && imageSrc && (
            <ImageCropper
              imageSrc={imageSrc}
              aspect={1448 / 469}
              onCropComplete={handleCropComplete}
              onCancel={handleCropCancel}
            />
          )}

          {loading ? (
            <p>Loading sponsor images...</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {sponsors.map((sponsor) => (
                <div
                  key={sponsor._id}
                  className="border p-2 rounded shadow flex flex-col items-center"
                >
                  <img
                    // Prepend API_BASE to load from correct server domain
                    src={`${API_BASE}/uploads/sponsors/${sponsor.filename}`}
                    alt="Sponsor"
                    className="w-full h-32 object-contain mb-2"
                  />
                  <button
                    onClick={() => handleDelete(sponsor._id)}
                    className="bg-red-500 text-white px-2 py-1 rounded mt-auto"
                  >
                    Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AdminSponsorManagement;
